// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IPublicSuburbanV1CreateRealtyRequest,
  TPublicSuburbanV1CreateRealtyModel,
  IMappers,
  TPublicSuburbanV1CreateRealtyResponse,
  IPublicSuburbanV1CreateRealtyResponse,
  IPublicSuburbanV1CreateRealtyResponseError,
} from './types';

export const defaultConfig: TPublicSuburbanV1CreateRealtyModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'price-estimator',
  pathApi: '/suburban/v1/create-realty/',
  requestType: 'json',
} as TPublicSuburbanV1CreateRealtyModel;

export function createPublicSuburbanV1CreateRealtyModel(
  parameters: IPublicSuburbanV1CreateRealtyRequest,
): TPublicSuburbanV1CreateRealtyModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IPublicSuburbanV1CreateRealtyOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IPublicSuburbanV1CreateRealtyRequest;
}

export async function fetchPublicSuburbanV1CreateRealty<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicSuburbanV1CreateRealtyOptions<TResponse200, TResponse400>): Promise<
  TPublicSuburbanV1CreateRealtyResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createPublicSuburbanV1CreateRealtyModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicSuburbanV1CreateRealtyResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IPublicSuburbanV1CreateRealtyResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TPublicSuburbanV1CreateRealtyResponse;
}
